import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Select } from '@src/elements/select/select'
import { OptionGroup } from '@src/elements/select/option-group'
import { ClearOption, Option } from 'src/elements/select/option'

import './filter.sass'
import { UI_RETENTION_FLAG_TO_BACKEND_FLAG } from '@src/util/constants'

// named explicitly, the class name is the svg element <filter>, which vue refuses as a component name
@Component({ name: 'ContentFilter' })
export class Filter extends Vue {

  @Prop({
    required: false, default: function () {
      return []
    }
  })
  filterList: Array<any>

  @Prop({ required: false, default: () => [] })
  counter: Array<any>

  @Prop({ required: true })
  placeholder: string

  @Prop({ required: true })
  tag: string

  @Prop({ required: true })
  translation: string

  @Prop({
    required: false, default: function () {
      return new Set([])
    }
  })
  selectedFilters: Set<string>

  @Prop({
    required: false, default: () => []
  })
  mappedFilters: string []

  @Prop({ required: true })
  filterCallback: (item: string) => void

  @Prop({ required: false })
  clearAllCallback: (items: string[]) => void

  @Prop({ required: false, default: '' })
  cssClass: string

  @Prop({ required: false, default: true })
  showClearAll: boolean

  @Prop({ required: false, default: false })
  mapToBackendFilters: boolean

  private hasSelectedFilters: boolean = false

  constructor (props) {
    super(props)
  }

  clearAll () {
    this.clearAllCallback(this.filterList)
  }

  updated () {
    const listOfFilters = this.mapToBackendFilters ? this.mappedFilters : this.filterList
    if (this.selectedFilters) {
      for (let i = 0; i < listOfFilters.length; i++) {
        if (this.selectedFilters.has(listOfFilters[i])) {
          this.hasSelectedFilters = true
          return
        }
      }
    }
    this.hasSelectedFilters = false
  }

  render (h: CreateElement) {
    if (!this.filterList) {
      return
    }

    const filters = this.filterList.map((filter, index) => {
      // count the selected filters
      return <Option value={filter} label={this.$t(this.translation + filter.toUpperCase())}
                     detail={this.counter[index] ? this.counter[index].toString() : ''}
                     selected={this.selectedFilters && this.selectedFilters.has(this.mapToBackendFilters ? UI_RETENTION_FLAG_TO_BACKEND_FLAG[filter] : filter)}
                     select={this.filterCallback} class={filter} />
    })

    return <div class={`filterWrapper ${this.cssClass}`}>
      <Select class={'filter' + (this.hasSelectedFilters ? ' selected' : '')} value={this.placeholder} ref={this.tag}>
        <OptionGroup extraStyles={{ height: '26vh' }} >
          {this.showClearAll ?
            <ClearOption class='filter-clear' value='all' label={this.$t('PAGE.CONTENT.WORKOUTS.CLEAR_FILTERS')}
                         select={this.clearAll} /> : ''}
          {filters}
        </OptionGroup>
      </Select>
      <div class='filter-name'>{this.placeholder}</div>
    </div>
  }
}
